module.exports = __webpack_public_path__ + "static/img/start.8fa9f21d.png";